export const translations = {
  en: {
    // Navigation
    nav: {
      logo: "Unframed"
    },

    // Hero Section
    hero: {
      tagline: "We Don't Sell Services.",
      tagline2: "We Sell Results.",
      subtitle: "From strategy to execution — we scale brands and crush targets.",
      cta: "Book Your Call",
      stats: {
        stat1: "$5M+ in profitable media buying",
        stat2: "100+ websites built",
        stat3: "15+ businesses automated"
      }
    },

    // Video Section
    video: {
      name: "Benjamin",
      title: "CEO & Co-Founder",
      url: "https://customer-bgwniqrr523xvn7e.cloudflarestream.com/2d7f94b5d41f8b1edec3e4ddf20f64e7/iframe?preload=true"
    },

    // Who We Are Section
    whoWeAre: {
      title: "Who We Are",
      intro: "We are two founders backed by a team that combines the best of the marketing and tech worlds.",
      supportText: "We can support multiple aspects of your business:",
      services: [
        "Marketing",
        "Sales", 
        "Business processes",
        "Automation and technical solutions"
      ],
      vision: "Different skills. Same vision. Same hunger.",
      goal: "All with one sole goal - increasing your sales and revenue.",
      image: "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/f23e0313-b8fe-4759-6a78-4b71993a8500/public"
    },

    // Philosophy Section
    philosophy: {
      title: "Rules Don't Grow Companies. Results Do.",
      subtitle: "We start with the end goal and reverse-engineer the fastest, most profitable path. No unnecessary complexity, no vanity metrics—just strategic execution that delivers measurable growth for ambitious brands.",
      cards: [
        {
          title: "No fluff — only measurable outcomes",
          description: "Every strategy, every campaign, every decision is measured against real business results."
        },
        {
          title: "Data-driven creativity",
          description: "Creative solutions backed by solid data analysis and market insights."
        },
        {
          title: "Partner, not service provider",
          description: "We're invested in your success because your growth is our growth."
        }
      ]
    },

    // Services Section
    services: {
      title: "What We Do",
      key_benefits_label: "Key Benefits:",
      items: [
        {
          title: "Marketing Strategy",
          description: "We create marketing strategies designed around your business goals and target audience.",
          detail: "Strategic planning and execution that aligns with your business objectives and market opportunities.",
          benefits: [
            "Strategic planning and market research",
            "Target audience analysis and segmentation",
            "Competitive analysis and positioning",
            "ROI-focused campaign planning"
          ]
        },
        {
          title: "Paid Traffic",
          description: "Profitable clicks, not just clicks.",
          detail: "Strategic media buying that focuses on ROI and sustainable growth.",
          benefits: [
            "Profitable ad spend optimization",
            "Advanced audience targeting",
            "Real-time performance monitoring"
          ]
        },
        {
          title: "Funnels",
          description: "Customer journeys engineered to convert.",
          detail: "High-converting sales funnels that guide prospects to purchase.",
          benefits: [
            "High-converting landing pages",
            "Optimized customer journey mapping",
            "A/B tested conversion elements"
          ]
        },
        {
          title: "Business Automations",
          description: "Scale on autopilot.",
          detail: "Automated systems that handle growth while you focus on strategy.",
          benefits: [
            "24/7 automated workflows",
            "Smart lead nurturing systems",
            "Scalable business processes"
          ]
        }
      ]
    },

    // Formula Section
    formula: {
      title: "The Unframed Formula",
      items: [
        {
          step: "01",
          title: "Understand your business & identify challenges",
          description: "First, we dig deep into your goals, workflows, and pain points. By doing this, we ensure our solutions address the most critical needs."
        },
        {
          step: "02",
          title: "Strategise the solution",
          description: "Once we pinpoint the challenges, we propose a tailored strategy, actionable, and aligned with your objectives."
        },
        {
          step: "03",
          title: "Move forward with implementation",
          description: "When you're happy with the plan, we go full steam ahead: executing the strategy and keeping you in the loop every step of the way."
        },
        {
          step: "04",
          title: "Scale & increase revenue",
          description: "After successful implementation, we help you optimise, scale, and expand. The focus shifts toward growth, ensuring your business continues to thrive and revenue consistently increases."
        }
      ]
    },

    // Edge Section
    edge: {
      title: "Why Work With Us",
      subtitle: "The Unframed Edge for established brands ready to scale",
      items: [
        "We don't chase trends, we create systems that work",
        "Results-first approach means every dollar is accountable",
        "Direct access to strategy, not account managers",
        "Built for brands ready to grow aggressively"
      ]
    },

    // Clients Section
    clients: {
      title: "Who We Worked With",
      logos: [
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/2b22c384-3d95-4a6f-ac14-8d7a49b06d00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/bdc4004a-8300-468a-07ea-05321e968200/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/9efd4022-6318-4f33-1b05-d09ef6dd5c00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/e9932ee3-86af-49cd-6b2e-ad0a278ab100/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/8c97e937-bbcf-49e1-da7d-32fc3059c700/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/ea957fd1-2102-4f32-2728-6c9081f89d00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/e529a3ea-22d5-4bdf-e1cc-2ed95d711c00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/235d6d39-4c2c-42d9-b630-dbecb0ed1300/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/fb6206cb-c9a3-4772-cad3-e2cb1fd46200/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/dd28035b-11f9-482d-e99a-313b1ff4e700/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/7dea2b72-bf93-4fd7-fcb7-e4c0d4de9900/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/afb2fb26-102a-4376-e015-37648570a600/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/3a01aca6-f924-47d9-e0d1-ebf6e6530b00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/9247eab5-8f8d-46ce-9e05-d067c6f54700/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/7527fc24-358b-4639-5cfc-f2b26b194600/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/393db646-5e3e-4897-71ce-8d63597b3400/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/56b40585-e8a9-4f21-fdc0-74c831b11d00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/e9a86a43-3885-4a26-4041-c91021931900/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/bf38a67b-f454-48f9-5acd-abc486482100/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/ea9141ed-8908-4a8b-01ab-a9d98f2e5000/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/19e8e887-46d1-4ebc-834e-c4bcc8e15300/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/7fd191d6-c2b5-4799-6fb2-77582e454c00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/b5b9859d-222a-4890-1a88-40af92d54400/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/34ce26d3-858c-4d60-466c-20f0c6d59e00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/3a397dcf-2ddf-44a8-a329-f52033043b00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/e0e7fa59-8e8c-4210-463e-c09aac9c0800/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/f2423711-e318-47da-8c5a-3dc2e1b22d00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/2504ca9e-1749-4200-a344-ffcde52f0c00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/762249ed-9b31-4bd3-330d-427d67b7b600/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/6c39c14b-b191-4ff0-bc52-eff48aea5d00/public"
      ]
    },

    // CTA Section
    cta: {
      title: "Ready to Break the Frame?",
      subtitle: "Let's talk about where you are, where you want to be, and if we can help you get there.",
      button: "Book Your Call"
    },

    // Contact Section
    contact: {
      title: "Let's Start the Conversation",
      form: {
        name: "Your Name *",
        email: "Your Email *",
        phone: "Your Phone Number *",
        company: "Company Name *",
        message: "Tell us about your goals and challenges... *",
        submit: "Send Message",
        required: "* All fields are required"
      },
      thank_you: {
        title: "Thank You!",
        message: "We've received your message and will get back to you within 24 hours.",
        tagline: "Ready to break the frame and deliver results!",
        button: "Send Another Message"
      }
    },

    // Footer
    footer: {
      tagline: "We Don't Sell Services. We Sell Results."
    },

    // Language Switcher
    language: {
      current: "English",
      switch_to: "Crnogorski"
    },

    // Plantaže Offer Page
    plantazeOffer: {
      // Header
      title: "Plantaže",
      header: "Offer for Digital Marketing and Social Media Management Services",
      client: "Plantaže 13.jul",
      headerSubtext: "Based on the meeting held on 08.09.2025, we are submitting an offer for improving digital communication and positioning Plantaže as a premium brand on social media.",
      
      // Sections
      whoWeAre: "Who Are We?",
      whatWeDo: "What We Do?",
      ourClients: "Clients We Have Worked With",
      
      // Main Goals
      mainGoals: {
        title: "Main Goal",
        goal1: "Presenting Plantaže 13. jul as a premium brand that offers top-quality products at affordable prices.",
        goal2: "Increasing visibility of Plantaže 13. Jul social media profiles.",
        goal3: "Presenting all umbrella products of Plantaže 13. Jul"
      },

      // Offer Section
      offer: {
        title: "Offer",
        
        strategy: {
          title: "1. Creating Marketing Strategy",
          description: "Goal: presenting Plantaže as a premium brand that offers the best wines in the region (and beyond) at affordable prices."
        },
        
        contentCreation: {
          title: "2. Content Creation",
          fieldTrips: "2 monthly field trips (photos + video) – up to 3h per trip.",
          reelsMaterial: "Material for creating 4 reels monthly.",
          reelsIncludes: "Includes all aspects needed for video to be quality and meaningful (script creation, filming, editing, animations, video assembly).",
          photos: "Photographs – number not defined in advance; sufficient number of photographs will be created according to the situation.",
          drone: "Shooting/filming with drone.",
          coordination: "Field trip is realized planned and coordinated with Plantaže team, so that realization is flawless.",
          team: "A photographer/videographer and one more person from the marketing team who coordinates the process go to the field."
        },
        
        socialMedia: {
          title: "3. Social Media Management",
          coordination: "Coordination with Plantaže 13. jul internal team.",
          preparation: "Preparation of content for publishing on social media.",
          posting: "Publishing approx. 3 posts weekly and approx. 2 stories daily.",
          note: "Note: we will not strictly adhere to this, but will act according to needs, timing, situation and strategy."
        },
        
        advertising: {
          title: "4. Traffic Purchase",
          description: "Purchasing content on Meta platforms (Facebook + Instagram) for greater visibility.",
          budget: "Budget up to €1,000 monthly (provided by Plantaže 13. jul)."
        },
        
        reports: {
          title: "5. Monthly Reports",
          activities: "Report on completed activities.",
          recommendations: "Plan and recommendations for the next period."
        },
        
        pricing: {
          title: "6. Service Price",
          price: "€1,000 + VAT / monthly."
        },
        
        additionalServices: {
          title: "Additional Services (As Needed)",
          extraSession: "Additional content creation session – €150.",
          outsidePodgorica: "Content creation outside Podgorica:",
          withinTrips: "If it falls within one of 2 field trips: travel costs + €75 daily allowance.",
          additionalTrip: "If it's an additional field trip: €150 + €75 daily allowance + travel costs.",
          promoVideos: "Production of longer promo videos (1–3 minutes) – €150/video.",
          models: "Professional models / makeup / styling at shoots – variable price (not dependent on us).",
          advertising: "Advertising in case of budget over €1,000:",
          budget1000: "€1,000–2,000 → additional €150.",
          budget2000: "€2,000–4,000 → additional €400.",
          budget4000: "€4,000–10,000 → additional €700.",
          budgetReason: "Reason: larger budgets mean more work, but also much greater responsibility to spend funds responsibly.",
          commercial: "Photos for billboards / catalogs / printed materials / promotional materials → commercial use is charged separately. €150-300",
          events: "Special events (fairs, festivals, corporate events) → not included in regular package, charged by agreement. €150-300"
        },
        
        duration: {
          title: "8. Note on Cooperation Duration",
          firstContract: "The first contract is signed for a maximum period of 3 months, which we consider the optimal period for cooperation evaluation.",
          renewal: "After the initial contract expires, a new contract is signed based on agreement on further business conditions."
        }
      },

      // Client Responsibilities
      clientResponsibilities: {
        title: "Client Responsibilities",
        
        communication: {
          title: "1. Communication Timeliness",
          response: "Client is obliged to respond to email/message within reasonable time (no later than 24h).",
          delays: "In case of delays with feedback, deadlines for posts and delivery are moved proportionally."
        },
        
        materials: {
          title: "2. Material Delivery",
          responsibility: "Client is responsible for providing all necessary logos, brand books, visuals, photographs, video archives and other materials needed for content creation."
        },
        
        approval: {
          title: "3. Content Review and Approval",
          review: "Client is obliged to review and approve proposed content (copy, visuals, video) before publication, within 3 days.",
          delay: "If they don't manage to give feedback within agreed time, the content release deadline is moved."
        },
        
        access: {
          title: "4. Access to Channels and Accounts",
          provide: "Client is obliged to provide administrative access to social media, advertising accounts (Meta Business Manager), Google Analytics and other relevant platforms."
        },
        
        budget: {
          title: "5. Ad Budget Approval",
          approval: "Client is obliged to provide and approve monthly budget for paid advertising on time (optional).",
          payment: "Ad budget is not included in package price and is paid directly to platforms (Meta, Google)."
        },
        
        resources: {
          title: "6. Internal Resources Organization",
          contact: "Client is obliged to appoint one contact person who will make final decisions and provide feedback.",
          logistics: "Client should provide logistics at shoots (access to locations: vineyards, restaurants, Sipčanik, etc.)."
        },
        
        events: {
          title: "7. Timely Event Information",
          notification: "Client is obliged to notify agency in advance about important events (fairs, promotions, new wine launches) minimum 7 days earlier, so content and logistics can be prepared."
        },
        
        payment: {
          title: "8. Respecting Agreed Payment Deadlines",
          obligation: "Client commits to pay monthly fee within 7 days of invoice issuance."
        },
        
        brandConsistency: {
          title: "9. Respecting Brand Communication",
          commitment: "Client commits not to publish content independently (outside agreement), without prior agency notification, to preserve communication consistency."
        }
      },

      // Contact
      contact: {
        title: "Contact",
        contactLabel: "Contact us:",
        callLabel: "Call us:"
      }
    }
  },

  me: {
    // Navigation
    nav: {
      logo: "Unframed"
    },

    // Hero Section
    hero: {
      tagline: "Ne Prodajemo Usluge.",
      tagline2: "Prodajemo Rezultate.",
      subtitle: "Od strategije do izvršenja — skaliramo brendove i postižemo ciljeve.",
      cta: "Zakažite Poziv",
      stats: {
        stat1: "5M$+ u profitabilnom oglašavanju",
        stat2: "100+ sajtova izgrađeno",
        stat3: "15+ biznisa automatizovano"
      }
    },

    // Video Section
    video: {
      name: "Benjamin",
      title: "CEO & Co-Founder",
      url: "https://customer-bgwniqrr523xvn7e.cloudflarestream.com/2d7f94b5d41f8b1edec3e4ddf20f64e7/iframe?preload=true"
    },

    // Who We Are Section
    whoWeAre: {
      title: "Ko Smo Mi",
      intro: "Mi smo dva osnivača podržana timom koji kombinuje najbolje iz marketinškog i tehnološkog svijeta.",
      supportText: "Možemo podržati više aspekata vašeg biznisa:",
      services: [
        "Marketing",
        "Prodaja",
        "Poslovni procesi", 
        "Automatizacija i tehnička rješenja"
      ],
      vision: "Različite vještine. Ista vizija. Ista glad.",
      goal: "Sve sa jednim jedinim ciljem - povećanje vaših prodaja i prihoda.",
      image: "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/f23e0313-b8fe-4759-6a78-4b71993a8500/public"
    },

    // Philosophy Section
    philosophy: {
      title: "Kompanije Ne Rastu Na Pravilima. Rastu Na Rezultatima.",
      subtitle: "Krećemo od cilja i gradimo najbrži, najprofitabilniji put. Bez komplikovanja, bez našminkane statistike — samo strategija koja donosi mjerljiv rast za ambiciozne brendove.",
      cards: [
        {
          title: "Bez floskula — samo mjerljivi ishodi",
          description: "Svaka strategija, svaka kampanja, svaka odluka se mjeri prema stvarnim poslovnim rezultatima."
        },
        {
          title: "Kreativnost zasnovana na podacima",
          description: "Kreativna rješenja podržana čvrstom analizom podataka i tržišnim uvidima."
        },
        {
          title: "Partner, ne pružalac usluga",
          description: "Ulažemo u vaš uspjeh jer je vaš rast i naš rast."
        }
      ]
    },

    // Services Section
    services: {
      title: "Šta Radimo",
      key_benefits_label: "Ključne Prednosti:",
      items: [
        {
          title: "Marketinška Strategija",
          description: "Kreiramo marketinške strategije dizajnirane oko ciljeva vašeg biznisa i ciljane publike.",
          detail: "Strateško planiranje i izvršavanje koje se usklađuje sa vašim poslovnim ciljevima i tržišnim mogućnostima.",
          benefits: [
            "Strateško planiranje i istraživanje tržišta",
            "Analiza i segmentacija ciljane publike", 
            "Konkurentska analiza i pozicioniranje",
            "ROI-usmjereno planiranje kampanja"
          ]
        },
        {
          title: "Plaćeno oglašavanje",
          description: "Profitabilni klikovi, ne samo klikovi.",
          detail: "Strateško online oglašavanje koje se fokusira na ROI i održiv rast.",
          benefits: [
            "Optimizacija profitabilnih reklamnih troškova",
            "Napredno targetovanje publike",
            "Praćenje performansi u realnom vremenu"
          ]
        },
        {
          title: "Funeli",
          description: "Putanje korisnika dizajnirane za konverziju.",
          detail: "Visoko konvertujući prodajni funeli koji vode potencijalne kupce do kupovine.",
          benefits: [
            "Visoko konvertujuće landing stranice",
            "Optimizovano mapiranje putanje korisnika",
            "A/B testirani elementi konverzije"
          ]
        },
        {
          title: "Poslovne Automatizacije",
          description: "Skaliraj na autopilotu.",
          detail: "Automatizovani sistemi koji se bave rastom dok se ti fokusiraš na strategiju.",
          benefits: [
            "24/7 automatizovani tokovi rada",
            "Pametni sistemi za njegovanje potencijalnih kupaca",
            "Skalabilni poslovni procesi"
          ]
        }
      ]
    },

    // Formula Section
    formula: {
      title: "Unframed Formula",
      items: [
        {
          step: "01",
          title: "Razumijevanje vašeg biznisa i identifikovanje izazova",
          description: "Prvo, duboko istražujemo vaše ciljeve, tokove rada i probleme. Ovim osiguravamo da naša rješenja adresiraju najkritičnije potrebe."
        },
        {
          step: "02",
          title: "Strategija rješenja",
          description: "Kad identifikujemo izazove, predlažemo prilagođenu strategiju, praktičnu i usklađenu sa vašim ciljevima."
        },
        {
          step: "03",
          title: "Prelazimo na implementaciju",
          description: "Kad ste zadovoljni planom, idemo punom parom: izvršavamo strategiju i držimo vas u toku sa svakim korakom."
        },
        {
          step: "04",
          title: "Skaliranje i povećanje prihoda",
          description: "Nakon uspješne implementacije, pomažemo vam da optimizujete, skalirate i proširite. Fokus se prebacuje na rast, osiguravajući da vaš biznis nastavlja da napreduje i prihodi stalno rastu."
        }
      ]
    },

    // Edge Section
    edge: {
      title: "Zašto Mi",
      subtitle: "Unframed. Prednost za afirmisane brendove spremne za skaliranje",
      items: [
        "Ne slijedimo trendove, stvaramo sisteme koji rade",
        "Pristup 'rezultati na prvom mjestu' znači da se svaki euro računa",
        "Direktan pristup strategiji, ne account menadžerima",
        "Izgrađeno za brendove spremne da agresivno rastu"
      ]
    },

    // Clients Section
    clients: {
      title: "Sa Kim Smo Radili",
      logos: [
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/2b22c384-3d95-4a6f-ac14-8d7a49b06d00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/bdc4004a-8300-468a-07ea-05321e968200/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/9efd4022-6318-4f33-1b05-d09ef6dd5c00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/e9932ee3-86af-49cd-6b2e-ad0a278ab100/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/8c97e937-bbcf-49e1-da7d-32fc3059c700/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/ea957fd1-2102-4f32-2728-6c9081f89d00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/e529a3ea-22d5-4bdf-e1cc-2ed95d711c00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/235d6d39-4c2c-42d9-b630-dbecb0ed1300/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/fb6206cb-c9a3-4772-cad3-e2cb1fd46200/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/dd28035b-11f9-482d-e99a-313b1ff4e700/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/7dea2b72-bf93-4fd7-fcb7-e4c0d4de9900/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/afb2fb26-102a-4376-e015-37648570a600/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/3a01aca6-f924-47d9-e0d1-ebf6e6530b00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/9247eab5-8f8d-46ce-9e05-d067c6f54700/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/7527fc24-358b-4639-5cfc-f2b26b194600/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/393db646-5e3e-4897-71ce-8d63597b3400/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/56b40585-e8a9-4f21-fdc0-74c831b11d00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/e9a86a43-3885-4a26-4041-c91021931900/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/bf38a67b-f454-48f9-5acd-abc486482100/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/ea9141ed-8908-4a8b-01ab-a9d98f2e5000/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/19e8e887-46d1-4ebc-834e-c4bcc8e15300/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/7fd191d6-c2b5-4799-6fb2-77582e454c00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/b5b9859d-222a-4890-1a88-40af92d54400/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/34ce26d3-858c-4d60-466c-20f0c6d59e00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/3a397dcf-2ddf-44a8-a329-f52033043b00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/e0e7fa59-8e8c-4210-463e-c09aac9c0800/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/f2423711-e318-47da-8c5a-3dc2e1b22d00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/2504ca9e-1749-4200-a344-ffcde52f0c00/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/762249ed-9b31-4bd3-330d-427d67b7b600/public",
        "https://imagedelivery.net/bsJiXVjZz9CYOTIw_HoJ7g/6c39c14b-b191-4ff0-bc52-eff48aea5d00/public"
      ]
    },

    // CTA Section
    cta: {
      title: "Spremni Da Krenete Naprijed?",
      subtitle: "Razgovarajmo o tome gdje ste, gdje želite biti, i da li možemo pomoći da tamo dođete.",
      button: "Zakažite Poziv"
    },

    // Contact Section
    contact: {
      title: "Počnimo Razgovor",
      form: {
        name: "Vaše Ime *",
        email: "Vaš Email *",
        phone: "Vaš Broj Telefona *",
        company: "Naziv Kompanije *",
        message: "Recite nam o vašim ciljevima i izazovima... *",
        submit: "Pošaljite Poruku",
        required: "* Sva polja su obavezna"
      },
      thank_you: {
        title: "Hvala Vam!",
        message: "Primili smo vašu poruku i javićemo vam se u roku od 24 sata.",
        tagline: "Spremni da prolomimo okvir i isporučimo rezultate!",
        button: "Pošaljite Drugu Poruku"
      }
    },

    // Footer
    footer: {
      tagline: "Ne Prodajemo Usluge. Prodajemo Rezultate."
    },

    // Language Switcher
    language: {
      current: "Crnogorski",
      switch_to: "English"
    },

    // Plantaže Offer Page
    plantazeOffer: {
      // Header
      title: "Plantaže",
      header: "Ponuda za usluge digitalnog marketinga i upravljanja društvenim mrežama",
      client: "Plantaže 13.jul",
      headerSubtext: "Na osnovu održanog sastanka dana 08.09.2025, dostavljamo ponudu za unapređenje digitalne komunikacije i pozicioniranje Plantaža kao premium brenda na društvenim mrežama.",
      
      // Sections
      whoWeAre: "Ko Smo Mi?",
      whatWeDo: "Šta Radimo?",
      ourClients: "Klijenti sa kojima smo dosad radili",
      
      // Main Goals
      mainGoals: {
        title: "Glavni Cilj",
        goal1: "Predstavljanje Plantaža 13. jul kao premium brenda koji nudi vrhunske proizvode uz pristupačne cijene.",
        goal2: "Povećanje vidljivosti profila društvenih mreža Plantaža 13. Jul.",
        goal3: "Predstavljanje svih krovnih proizvoda Plantaža 13. Jul"
      },

      // Offer Section
      offer: {
        title: "Ponuda",
        
        strategy: {
          title: "1. Kreiranje marketinške strategije",
          description: "Cilj: predstavljanje Plantaža kao premium brenda koji nudi najbolja vina u regionu (ali i šire) uz pristupačne cijene."
        },
        
        contentCreation: {
          title: "2. Kreiranje sadržaja",
          fieldTrips: "2 izlaska mjesečno na teren (fotografije + video) – do 3h po izlasku.",
          reelsMaterial: "Materijal za kreiranje 4 reels-a mjesečno.",
          reelsIncludes: "Uključeni svi aspekti potrebni da video bude kvalitetan i smislen (kreiranje skripte, snimanje, editing, animacije, sklapanje videa).",
          photos: "Fotografije – broj se ne definiše unaprijed; biće kreiran dovoljan broj fotografija u skladu sa situacijom.",
          drone: "Slikanje/snimanje dronom.",
          coordination: "Izlazak na teren se realizuje isplanirano i koordinisano sa timom Plantaža, kako bi realizacija bila besprekorna.",
          team: "Na teren izlazi fotograf/videograf i još jedna osoba iz marketing tima koja koordinira proces."
        },
        
        socialMedia: {
          title: "3. Održavanje društvenih mreža",
          coordination: "Koordinacija sa internim timom Plantaža 13. jul.",
          preparation: "Priprema sadržaja za objavljivanje na društvenim mrežama.",
          posting: "Objavljivanje cca. 3 posta nedjeljno i cca. 2 storija dnevno.",
          note: "Napomena: ovoga se nećemo striktno pridržavati, već ćemo u skladu sa potrebama, tajmingom, situacijom i strategijom djelovati."
        },
        
        advertising: {
          title: "4. Kupovina saobraćaja",
          description: "Kupovina sadržaja na Meta platformama (Facebook + Instagram) u svrhu veće vidljivosti.",
          budget: "Budžet do 1.000 EUR mjesečno (obezbjeđuje Plantaže 13. jul)."
        },
        
        reports: {
          title: "5. Mjesečni izvještaji",
          activities: "Izvještaj o urađenim aktivnostima.",
          recommendations: "Plan i preporuke za naredni period."
        },
        
        pricing: {
          title: "6. Cijena usluga",
          price: "1.000 EUR + PDV / mjesečno."
        },
        
        additionalServices: {
          title: "Dodatne usluge (po potrebi)",
          extraSession: "Dodatna sesija kreiranja sadržaja – 150 EUR.",
          outsidePodgorica: "Kreiranje sadržaja van Podgorice:",
          withinTrips: "Ako spada u jedno od 2 izlaska na teren: putni troškovi + 75 EUR dnevnica.",
          additionalTrip: "Ako je dodatni izlazak na teren: 150 EUR + 75 EUR dnevnica + putni troškovi.",
          promoVideos: "Produkcija dužih promo videa (1–3 minuta) – 150 EUR/video.",
          models: "Profesionalni modeli / šminka / stilizacija na snimanjima – varijabilna cijena (ne zavisi od nas).",
          advertising: "Oglašavanje u slučaju budžeta preko 1.000 EUR:",
          budget1000: "1.000–2.000 EUR → dodatnih 150 EUR.",
          budget2000: "2.000–4.000 EUR → dodatnih 400 EUR.",
          budget4000: "4.000–10.000 EUR → dodatnih 700 EUR.",
          budgetReason: "Razlog: veći budžeti znače više posla, ali i mnogo veću odgovornost da se sredstva potroše odgovorno.",
          commercial: "Fotografije za bilborde / kataloge / štampane materijale / promotivne materijale → posebno naplaćuje se komercijalno korišćenje. 150-300eur",
          events: "Specijalni događaji (sajmovi, festivali, korporativni eventi) → ne ulaze u redovni paket, naplaćuju se po dogovoru. 150-300eur"
        },
        
        duration: {
          title: "8. Napomena o dužini saradnje",
          firstContract: "Prvi ugovor se potpisuje na period od maksimalno 3 mjeseca, što smatramo optimalnim periodom za evaluaciju saradnje.",
          renewal: "Nakon isteka inicijalnog ugovora, potpisuje se novi ugovor na osnovu dogovora o daljim uslovima poslovanja."
        }
      },

      // Client Responsibilities
      clientResponsibilities: {
        title: "Odgovornosti klijenta",
        
        communication: {
          title: "1. Ažurnost u komunikaciji",
          response: "Klijent je dužan da odgovori na e-mail/poruku u razumnom roku (najkasnije u roku od 24h).",
          delays: "U slučaju kašnjenja sa povratnim informacijama, rokovi za objave i isporuku pomjeraju se proporcionalno."
        },
        
        materials: {
          title: "2. Dostavljanje materijala",
          responsibility: "Klijent je odgovoran za dostavljanje svih potrebnih logotipa, brand book-a, vizuala, fotografija, video arhive i ostalog materijala koji su potrebni za kreiranje sadržaja."
        },
        
        approval: {
          title: "3. Pregled i odobravanje sadržaja",
          review: "Klijent je dužan da pregleda i odobri predloženi sadržaj (copy, vizuale, video) prije objave, u roku od 3 dana.",
          delay: "Ako ne stigne da da povratnu informaciju u dogovorenom roku, pomjera se rok za izbacivanje sadržaja."
        },
        
        access: {
          title: "4. Pristup kanalima i nalozima",
          provide: "Klijent je dužan da obezbijedi administrativni pristup društvenim mrežama, oglašivačkim nalozima (Meta Business Manager), Google Analytics-u i drugim relevantnim platformama."
        },
        
        budget: {
          title: "5. Odobravanje budžeta za oglase",
          approvals: "Klijent je dužan da obezbijedi i odobri mjesečni budžet za plaćeno oglašavanje na vrijeme (opcionalno).",
          payment: "Budžet za oglase nije uračunat u cijenu paketa i plaća se direktno platformama (Meta, Google)."
        },
        
        resources: {
          title: "6. Organizacija internih resursa",
          contact: "Klijent je dužan da imenuje jednu kontakt osobu koja će davati konačne odluke i povratne informacije.",
          logistics: "Klijent treba da obezbijedi logistiku na snimanjima (pristup lokacijama: vinogradi, restorani, Sipčanik, itd.)."
        },
        
        events: {
          title: "7. Pravovremeno informisanje o događajima",
          notification: "Klijent je obavezan da unaprijed obavijesti agenciju o važnim događajima (sajmovi, promocije, lansiranje novih vina) minimalno 7 dana ranije, kako bi se sadržaj i logistika mogli pripremiti."
        },
        
        payment: {
          title: "8. Poštovanje ugovorenih rokova plaćanja",
          obligation: "Klijent se obavezuje da uplati mjesečnu naknadu u roku od 7 dana od izdavanja fakture."
        },
        
        brandConsistency: {
          title: "9. Poštovanje brend komunikacije",
          commitment: "Klijent se obavezuje da ne objavljuje sadržaj samostalno (van dogovora), bez prethodnog informisanja agencije, kako bi se sačuvala konzistentnost komunikacije."
        }
      },

      // Contact
      contact: {
        title: "Kontakt",
        contactLabel: "Kontaktirajte nas:",
        callLabel: "Pozovite nas:"
      }
    }
  }
};

export const getTranslation = (currentLanguage, key) => {
  const keys = key.split('.');
  let translation = translations[currentLanguage];
  
  for (const k of keys) {
    if (translation && typeof translation === 'object') {
      translation = translation[k];
    } else {
      // Fallback to English if translation not found
      translation = translations.en;
      for (const fallbackKey of keys) {
        if (translation && typeof translation === 'object') {
          translation = translation[fallbackKey];
        } else {
          return key; // Return key if no translation found
        }
      }
      break;
    }
  }
  
  return translation || key;
};